// ===============================================================
//
// Delete popup model for CAD topology
// Called from CAD topology page
//
//
// 
//
//
// ===============================================================

import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PopupModal from '../PopupModal';
import { deleteConfigDataFromDatabase } from '../UserFunctions'
import PropTypes from 'prop-types';

class DeleteJsonDataModal extends Component {
    constructor(props){
        super(props)
        // Setting default values
        this.state = {
            data: undefined,
            togglePopup: false,
            popUpText: undefined
        }
        this.handleDeleteContent = this.handleDeleteContent.bind(this);
        this.closePopupModal = this.closePopupModal.bind(this);
    }

    // Delete function
    handleDeleteContent() {
        // Saving jsonData sent from CADtopology.js
        let jsonData = this.props.jsonfile
        // Saving description send from CADtopology.js
        let description = this.props.description
        delete jsonData[parseInt(this.props.deleteSelectedRow)]
        console.log("UUID passed to delete JSONN Modal",this.props.deleteJobUuid)
        //Creating payload with job_id to send to the function to delete from database
        const payload = {
            job_id : this.props.deleteJobUuid
        }
        // API call to delete the cad data from the database
        deleteConfigDataFromDatabase(`${window.location.origin}/delete_cad_data`,payload).then(
            (response) => {
                console.log(response)
                this.setState( (prevState) =>  {
                    // Open popup once it is deleted from database
                    return {
                        ...prevState,
                        togglePopup: true,
                        popUpText: `CAD Topology with description '${description}' has been deleted.`
                    }
                })
          }
          );
        this.props.setJsonfile(jsonData) 
    }
    // Close popup modal function
    closePopupModal() {
        this.setState( (prevState) => {
            return {
                ...prevState,
                togglePopup: false
            }
        })
        // Close the delete modal
        this.props.handleCloseDeleteModal();
    }

    componentDidMount() {
        this.setState( (prevState) => {
            return {
                ...prevState,
                data: this.props.deleteContent
            }
        })
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.deleteSelectedRow>=0}>
                    <ModalHeader
                        toggle={this.props.handleCloseDeleteModal}
                        style={{ color:"#524fa1" }}
                    >
                        Delete CAD Topology
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            Are you sure want to delete ?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn" style={{marginLeft: "70%", backgroundColor: "red" }} onClick={this.handleDeleteContent}>Delete</Button>
                      <Button className="btn" style={{marginRight: "30%"}} onClick={this.props.handleCloseDeleteModal}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                {this.state.togglePopup ? <PopupModal heading="Confirmation" text={this.state.popUpText} closePopup={this.closePopupModal} /> : undefined}
            </div>
        )
    }
}
DeleteJsonDataModal.propTypes={
jsonfile:PropTypes.string,
description:PropTypes.string,
deleteSelectedRow:PropTypes.string,
deleteJobUuid:PropTypes.string,
setJsonfile:PropTypes.string,
deleteContent:PropTypes.string,
handleCloseDeleteModal:PropTypes.string,

}
DeleteJsonDataModal.defaultProps= {
jsonfile:[],
description:[],
deleteSelectedRow:[],
deleteJobUuid:[],
setJsonfile:[],
deleteContent:[],
handleCloseDeleteModal:[],

}

export default DeleteJsonDataModal;
